import icInboxAll from '../../assets/images/svg/ic-inbox-all.svg';
import icInboxUnassign from '../../assets/images/svg/ic-inbox-unassign.svg';
import icInboxDone from '../../assets/images/svg/ic-inbox-done.svg';
import icInboxAllAssign from '../../assets/images/svg/ic-inbox-all-assigned.svg';
import icInboxBot from '../../assets/images/svg/ic-inbox-chatbot.svg';
import icInboxSpam from '../../assets/images/svg/ic-inbox-spam.svg';
import icInboxUnfollow from '../../assets/images/svg/ic-inbox-block.svg';

const INBOXICONTYPE = {
  all: icInboxAll,
  unassigned: icInboxUnassign,
  done: icInboxDone,
  all_private: icInboxAllAssign,
  private: icInboxDone,
  bot: icInboxBot,
  spam: icInboxSpam,
  unfollow: icInboxUnfollow,
};

export default INBOXICONTYPE;
